import { MutationTree } from 'vuex'
import { IBlockState } from './block-state.store';
import * as _ from './block-types.store';
import { ActivityStatus, CrudStatus } from '../../common/enums';
import { IBlock, BlockParameter, IBlockListingViewModel, IBlockParameter } from '../../models/block';
import { TicketListingViewModel, ITicketListingViewModel } from '../../models/ticket';
import { Pagination } from '../../models/generic/generic-pagination';
import { IBaseFilterParameter } from '../../models/base-filter.parameter';

export const mutations: MutationTree<IBlockState> = {

  [_.BLOCK_LOADING]: (state: IBlockState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  }
  , [_.BLOCK_DETAIL_LOADING]: (state: IBlockState, activityStatus: ActivityStatus) => {
    state.detailActivityStatus = activityStatus;
  }
  , [_.BLOCK_ACTION] : (state: IBlockState, actionStatus: CrudStatus ) => {
    state.crudActionStatus= actionStatus
  }
  , [_.BLOCK_SET_BLOCKS]: (state: IBlockState, payload: { pagination: any, blocks: IBlock[], activityStatus: ActivityStatus, merge: boolean }) => {
    if (payload.merge === false) {
      state.blocks = payload.blocks;
    }
    else {
      const blocks = state.blocks || [];
      const uniqueBlocks = payload.blocks.filter((item, index) => {
        return blocks.findIndex(t => t.id === item.id) === -1;
      });
      state.blocks = blocks.concat(uniqueBlocks)
    }

    state.activityStatus = ActivityStatus.Loaded;

    if (payload.pagination) {
      state.pagination = payload.pagination;
    }
  }
  , [_.BLOCK_EXTEND_BLOCKS] : (state: IBlockState, block: IBlockListingViewModel) => {
    if(state.blocks) state.blocks.unshift(block)
  }
  , [_.BLOCK_SPLICE_BLOCKS] : (state: IBlockState, blockId: number ) => {
     if(state.blocks && state.blocks.length){
       const blockIndex= state.blocks.map(block => block.id).indexOf(blockId)
       if(blockIndex !== -1) state.blocks = state.blocks.filter((block,index) => index !== blockIndex)
     }
  }
  , [_.BLOCK_UPDATE_BLOCKS] : (state: IBlockState, block : IBlockListingViewModel ) => {
    if(state.blocks && state.blocks.length) {
      state.blocks= state.blocks.map( currentBlock => {
        if(currentBlock.id !== block.id ) return currentBlock

        return {
          ...currentBlock,
          ...block
        }
      })
    }
  }
  , [_.BLOCK_SET_BLOCK]: (state: IBlockState, block: IBlockListingViewModel) => {
    state.currentBlock = {
      ...state.currentBlock,
      ...block
    };
    state.detailActivityStatus = ActivityStatus.Loaded;
  },
  [_.BLOCK_INCREMENT_TOTAL_APARTMENT] : (state: IBlockState) => {
    if(Object.keys(state.currentBlock).length){
      state.currentBlock= {
        ...state.currentBlock,
        totalApartment: ++state.currentBlock.totalApartment
      }
    }
  }
  , [_.BLOCK_DECREMENT_TOTAL_APARTMENT] : (state: IBlockState) => {
    if(Object.keys(state.currentBlock).length){
      state.currentBlock = {
        ...state.currentBlock,
        totalApartment: --state.currentBlock.totalApartment
      }
    }
  }
  , [_.BLOCK_INIT]: (state: IBlockState, payload: IBlock  ) => {
    state.block= payload
  },
  [_.BLOCK_SET_BLOCK_BY_FIELD] : (state: IBlockState, payload: IBlock ) => {
    state.block = Object.assign({}, state.block, {...payload});
  },
  [_.BLOCK_RESET_BLOCKS]: (state: IBlockState) => {
    state.blocks = [];
    state.blockParameter = new BlockParameter({
      orderKeys: ['name', 'city', 'totalApartment', 'totalInProgressTicket'],
      orderValues: [1, 1, -1, -1],
      $limit: 100,
      key: ''
    });
    state.pagination = new Pagination({ total: 0, limit: 100, skip: 0 });
    state.activityStatus = ActivityStatus.Loaded;
  }
  , [_.BLOCK_SET_PAREMETER]: (state: IBlockState, payload: IBlockParameter) => {
    state.blockParameter = Object.assign({}, state.blockParameter, payload);
  }
  , [_.BLOCK_SET_CURRENT_BLOCK_BY_ID]: (state: IBlockState, id: string) => {
    const blockId: number = parseInt(id);
    state.blockCurrentId = isNaN(blockId) ? null : blockId;
  }
  , [_.BLOCK_APARTMENT_SIDEBAR_SET_TICKETS]: (state: IBlockState, payload: {
    key: string,
    ticketRawData: ITicketListingViewModel[]
  }) => {
    state[payload.key] = payload.ticketRawData.map(x => new TicketListingViewModel(x));
  }
  , [_.BLOCK_RESET_BLOCKS]: (state: IBlockState, payload: {
    activityStatus: ActivityStatus,
    merge?: boolean,
    pagination?: any
  }) => {
    state.pagination = new Pagination({ total: 0, limit: 0, skip: 0 });
    state.blocks = [];
    state.activityStatus = ActivityStatus.NoActivity;
  }
  , [_.BLOCK_GET_DETAIL_STATISTIC]: (state: IBlockState, statisticData: any) => {
    state.statisticData = statisticData;
    state.detailActivityStatus = ActivityStatus.Loaded;
  }
  , [_.BLOCK_REDUCE_SIDEBAR_BLOCK]: (state: IBlockState, totalRecord: number) => {
    state.currentBlock.totalDocument = state.currentBlock.totalDocument + totalRecord;
  }
  , [_.BLOCK_ENTITY_PARAM_MODIFIER]: (state: IBlockState, param: IBaseFilterParameter | { q: string }) => {

    state.blockEntityParameter = Object.assign({}, state.blockEntityParameter, param)
    console.log(state.blockEntityParameter);
  },
  [_.BLOCK_SET_LOADER_STATE]: (state: IBlockState, payload: { key: any, value: boolean }) => {
    const map: Map<string,boolean> = typeof payload.key === 'string' ?
                                new Map([ [payload.key ,payload.value] ]) :
                                      new Map(payload.key.map( (key: string) => [key,payload.value]))

      state.loaders= new Map([
        ...state.loaders,
        ...map
      ])
  }
}



// WEBPACK FOOTER //
// ./src/store/block/block-mutations.store.ts